import { BookOpenText, Camera, ExternalLink, Home, Search, Type } from 'lucide-react'
import { Link, NavLink } from 'react-router-dom'
import { useLocalStorage } from '../hooks/useLocalStorage'
import { BrandLogo } from './BrandLogo'

export function AppShell({ children }: { children: React.ReactNode }) {
  const [font, setFont] = useLocalStorage<'small'|'normal'|'large'>('resod-font-size','normal')
  return <div className={`app font-${font}`}>
    <header className="site-header">
      <div className="header-inner">
        <Link to="/" className="brand" aria-label="ReSOD 쉬운 제품안내 홈"><BrandLogo/></Link>
        <div className="header-actions">
          <div className="font-control" role="group" aria-label="글씨 크기"><Type aria-hidden="true"/><button aria-pressed={font==='normal'} onClick={() => setFont('normal')}>기본 글씨</button><button aria-pressed={font==='large'} onClick={() => setFont('large')}>큰 글씨</button></div>
          <a className="official compact" href="https://www.resod.co.kr/" target="_blank" rel="noopener noreferrer">공식 홈페이지 <ExternalLink aria-hidden="true"/></a>
        </div>
      </div>
    </header>
    <main id="main">{children}</main>
    <footer className="site-footer">
      <div><strong>ReSOD 쉬운 제품안내</strong><p>제품정보를 쉽게 확인하기 위한 안내 서비스입니다. 질병의 진단이나 치료를 위한 서비스가 아닙니다. 약을 복용하거나 치료 중이라면 제품 섭취 전에 의료전문가에게 확인하세요.</p><small className="personal-app-notice">이 앱은 SOD회사가 아닌 개인이 사용 편의성을 위해 만든 것임을 밝힙니다.</small></div>
      <a className="official" href="https://www.resod.co.kr/" target="_blank" rel="noopener noreferrer">ReSOD 공식 홈페이지 <ExternalLink aria-hidden="true"/></a>
    </footer>
    <nav className="bottom-nav" aria-label="주요 메뉴">
      <NavLink to="/"><Home/><span>홈</span></NavLink><NavLink to="/products?focus=search"><Search/><span>이름 찾기</span></NavLink><NavLink to="/photo-search"><Camera/><span>사진 찾기</span></NavLink><NavLink to="/reference-guides"><BookOpenText/><span>자료</span></NavLink>
    </nav>
  </div>
}
